import React from 'react'

// plugin that creates slider
import nouislider from "nouislider";
import wNumb from "wnumb";

class CLCChartZoom extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      textValue: null,
      percent: null
    };
  }

  componentDidMount() {
    this.slider = this.refs.slider;

    nouislider.create(this.slider, {
      start: 0,
      connect: [false, true],
      step: 10,
      range: { min: 0, max: 100 },
      orientation: 'vertical',
      tooltips: false,
      format: wNumb({
        decimals: 0
      }),
      cssPrefix: "noUiChart-"
    });

    this.slider.noUiSlider.on('update', function () {
      if (this.props.onSet) {
        this.props.onSet(this.slider.noUiSlider.get());
      }
    }.bind(this))

    var handle = this.slider.querySelectorAll('.noUiChart-handle');
    for (var i = 0; i < handle.length; i++) {
      handle[i].classList.add("noUiChart-" + this.props.color);
    }

    if (this.props.val) {
      this.slider.noUiSlider.set(this.props.val);
    }

    if (this.props.onMount) {
      this.props.onMount(this.slider.noUiSlider);
    }

  }

  onSlide = (render, handle, value, un, percent) => {
    this.setState({
      textValue: value[0].toFixed(2),
      percent: percent[0].toFixed(2)
    });
  };

  render() {
    return (
      <div ref="slider"></div>
    );
  }
}

export default CLCChartZoom